import { useQuery } from '@tanstack/react-query'
import { getFieldglassJobPosting } from 'api/admin/fieldglass/getFieldglassJobPosting'
import { fieldglassKeys } from './keys'

type UseFieldglassJobPostingQueryRequest = Parameters<
  typeof getFieldglassJobPosting
>[0]

export function useFieldglassJobPostingQuery(
  request: UseFieldglassJobPostingQueryRequest | null
) {
  return useQuery({
    queryKey: fieldglassKeys.jobPosting(request ?? undefined),
    queryFn: () => {
      if (request === null) {
        throw new Error('A job posting id is required')
      }
      return getFieldglassJobPosting(request)
    },
    enabled: request !== null,
  })
}
